import { POP_MARKET_LIST, usePopQuery } from '@/hooks/usePopQuery';
import { IconLocationFill } from '@arco-design/iconbox-react-m4b-next';
import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';

export const RegionTab = ({ isInitd }: { isInitd?: boolean }) => {
  const { t } = useTranslation();
  const { region: activeRegion, setRegionQuery } = usePopQuery();
  const [inView, setInView] = useState(true);

  const isActiveRegion = region => {
    return isInitd && region.market_region === activeRegion;
  };

  return (
    <div>
      <InView
        onChange={inView => {
          setInView(inView);
        }}>
        <div />
      </InView>
      <div
        className={`w-full bg-neutral-white shadow-downS ${
          inView ? '' : 'fixed top-60 z-[100]'
        }`}>
        <div className="w-[1280px] mx-auto flex">
          <div className="relative flex-1 flex gap-4 justify-center items-center p-12 text-neutral-text1 font-semibold text-16 cursor-pointer">
            <IconLocationFill />
            {t('academy_pop_region_select', '选择跨境市场：')}
          </div>
          {POP_MARKET_LIST.map(region => (
            <div
              key={region.market_region}
              className="relative flex-1 flex justify-center p-12 text-neutral-text1 font-semibold text-16 cursor-pointer"
              style={{
                color: isActiveRegion(region) ? '#EB254C' : '',
              }}
              onClick={() => {
                setRegionQuery(region.market_region);
              }}>
              {t(region.market_name)}
              {isActiveRegion(region) ? (
                <div className="absolute w-full bottom-0 bg-[#EB254C] h-3"></div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
